import { AP_STATUS } from 'constants/payment/appointmentStatus.const';
import S from 'constants/string.const';

const NS = Object.freeze({ variant: 'noShow', icon: 'handDown', text: 'No Show' });
const CO = Object.freeze({ variant: 'paid', icon: 'partyFace', text: 'Checked Out' });

const AR = Object.freeze({ variant: 'arrived', icon: 'handUp', text: 'Arrived' });
const CA = Object.freeze({ variant: 'cancelled', icon: 'xCloseRed', text: 'Cancelled' });
const CF = Object.freeze({ variant: 'confirmed', icon: 'checkGreenFilled', text: 'Confirmed' });
const UN = Object.freeze({ variant: 'unconfirmed', icon: 'timesCircle', text: 'Unconfirmed' });
const NP = Object.freeze({ variant: 'needsPayment', icon: 'timesCircle', text: 'Online booking in progress' });
const CU = Object.freeze({
  variant: 'customerUnverified',
  icon: 'timesCircle',
  text: `Unconfirmed ${S.dot} Client Unverified`,
});

export const APM_STATE = Object.freeze({
  //
  // past only
  pns: 'P_NS', // past, no show
  pco: 'P_CO', // past, paid

  // paired past and future
  par: 'P_AR', // past, arrived
  far: 'F_AR', // future, arrived
  pca: 'P_CA', // past, cancelled
  fca: 'F_CA', // future, cancelled
  pcf: 'P_CF', // past, confirmed
  fcf: 'F_CF', // future, confirmed
  pcu: 'P_CU', // past, customer unverified
  fcu: 'F_CU', // future, customer unverified
  pnp: 'P_NP', // past, needs payment
  fnp: 'F_NP', // future, needs payment
  pun: 'P_UN', // past, unconfirmed
  fun: 'F_UN', // future, unconfirmed

  // both past and future
  del: '*_DE',
  delOne: '*_DO',
  delAll: '*_DA',

  // confirmation modal states
  pcu2pns: 'P_CU_2_P_NS',
  pnp2pns: 'P_NP_2_P_NS',
  pun2pns: 'P_UN_2_P_NS',
  pcf2pns: 'P_CF_2_P_NS',

  pns2par: 'P_NS_2_P_AR',
  pns2pcf: 'P_NS_2_P_CF',
  pns2pun: 'P_NS_2_P_UN',

  pca2par: 'P_CA_2_P_AR',
  pca2pcf: 'P_CA_2_P_CF',
  pca2pun: 'P_CA_2_P_UN',

  fca2par: 'F_CA_2_P_AR',
  fca2pcf: 'F_CA_2_P_CF',
  fca2pun: 'F_CA_2_P_UN',
});

export const AP_UI_FOR_STATUS = Object.freeze({
  [AP_STATUS.arrived]: AR,
  [AP_STATUS.canceled]: CA,
  [AP_STATUS.confirmed]: CF,
  [AP_STATUS.unconfirmed]: UN,
  [AP_STATUS.paid]: CO,
  [AP_STATUS.customerUnverified]: CU,
  [AP_STATUS.needsPayment]: NP,
  [AP_STATUS.noShow]: NS,

  //
  // older ones, they will overwrite the newer ones if names clash

  arrived: AR,
  cancelled: CA,
  confirmed: CF,
  unconfirmed: UN,
  paid: CO,
  customerUnverified: CU,
  needsPayment: NP,
  noShow: NS,
});

export const AP_UI_FOR_STATE = Object.freeze({
  [APM_STATE.pns]: NS,
  [APM_STATE.pco]: CF,
  [APM_STATE.par]: AR,
  [APM_STATE.far]: AR,
  [APM_STATE.pca]: CA,
  [APM_STATE.fca]: CA,
  [APM_STATE.pcf]: CF,
  [APM_STATE.fcf]: CF,
  [APM_STATE.pcu]: CU,
  [APM_STATE.fcu]: CU,
  [APM_STATE.pnp]: NP,
  [APM_STATE.fnp]: NP,
  [APM_STATE.pun]: UN,
  [APM_STATE.fun]: UN,
});

export const AP_STATUS_FOR_STATE = Object.freeze({
  [APM_STATE.pns]: AP_STATUS.noShow,
  [APM_STATE.pco]: AP_STATUS.paid,
  [APM_STATE.par]: AP_STATUS.arrived,
  [APM_STATE.far]: AP_STATUS.arrived,
  [APM_STATE.pca]: AP_STATUS.canceled,
  [APM_STATE.fca]: AP_STATUS.canceled,
  [APM_STATE.pcf]: AP_STATUS.confirmed,
  [APM_STATE.fcf]: AP_STATUS.confirmed,
  [APM_STATE.pcu]: AP_STATUS.customerUnverified,
  [APM_STATE.fcu]: AP_STATUS.customerUnverified,
  [APM_STATE.pnp]: AP_STATUS.needsPayment,
  [APM_STATE.fnp]: AP_STATUS.needsPayment,
  [APM_STATE.pun]: AP_STATUS.unconfirmed,
  [APM_STATE.fun]: AP_STATUS.unconfirmed,
  [APM_STATE.del]: AP_STATUS.deleted,
});

export const APM_EVENT = Object.freeze({
  arrived: 'arrived',
  cancel: 'cancel',
  confirm: 'confirm',
  continue: 'continue',
  delOne: 'delete',
  delAll: 'deleteAll',
  noShow: 'noShow',
  rebook: 'rebook', // NOTE: unused because of wizards
  refresh: 'refresh',
  revert: 'revert',
  skip: 'skip',
  tick: 'tick',
});

export const AP_HISTORY_ORIGIN = Object.freeze({
  booking: 'online_booking',
  patch: 'patch_test',
  salon: 'salon_created',
});
